export default __webpack_public_path__ + "static/media/Qios_logo-white-1.4346c142.png";